import { Divider } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import { StyledComponentProps } from "@mui/styles";
import { HeaderStylesClassKey } from "assets/jss/layouts/headerLinksStyle";
import IconCreatePublication from "components/Icons/IconCreatePublication";
import { WithSnackbar, withSnackbar } from "components/SnackbarProvider/Snackbar";
import PublicationTypeName from "components/Translations/PublicationTypeName";
import { AccessKeys } from "Constants";
import LibUtils from "lib/LibUtils";
import { PublicationType, SystemRoles } from "models/ApiEnums";
import { SavePublicationResult } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { RoutePaths } from "routes/RouteConfig";
import Session from "services/Session";
import { FeedPostWindowMessages } from "store/feed/windowMessages";
import { GetPublicationResultMessage } from "views/Publication/Components/GetPublicationResultMessage";
import { publicationFactory } from "views/Timeline/Components/FeedHelpers";
import TopicEdit from "views/Topic/Components/TopicEdit";
import { TopicAdminRouteStateProps } from "views/Topic/TopicAdminList";
import moment from "moment";
import HeaderLinkButton from "./HeaderLinkButton";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    open: boolean;
    dlg: any;
}

interface IProps {
}

type Props = IProps & StyledComponentProps<HeaderStylesClassKey> & WithSnackbar & RouteComponentProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////

class HeaderCreationMenu extends React.Component<Props, IState> {

    private feedMessages = new FeedPostWindowMessages(window);

    ///
    constructor(props: Props) {
        super(props);
        this.state = {
            open: false,
            dlg: null
        };
    }

    ///
    private handleToggle() {
        this.setState(state => ({ open: !this.state.open }));
    };

    ///
    private handleClosePublication = (result: SavePublicationResult) => {

        var currentDate = moment().utc();

        if (result != null) {
            var r = GetPublicationResultMessage(result);
            if (r.message) this.props.snackbar.showMessage(r.message, r.messageOption);

            // Deve publicar/atualizar o feed atualmente exibido?
            if (result.approved) {

                // Adiciona no feed somente se o feed por minhas publicações ou a visualização não é futura
                var tryAddFeedData = result.viewPeriodStart == null || result.viewPeriodStart <= currentDate.toDate() ||
                                     document.location.pathname.indexOf(RoutePaths.TimelinePublications) > -1;

                if (tryAddFeedData) {
                    this.feedMessages.tryAddFeedData(result.publicationId, result.publicationType);
                }
                else if (document.location.pathname.indexOf(RoutePaths.TimelinePrefix + "/topic/") > -1) {
                    const topicId = document.location.pathname.substr(document.location.pathname.lastIndexOf('/') + 1);
                    if (result.topics.findIndex(p => p == topicId) > -1) {
                        this.feedMessages.tryFeedReset();
                    }
                }
            }
        }
        this.setState({ open: false, dlg: null });
    };

    ///
    private handleCloseTopic = () => {
        this.setState({ open: false, dlg: null },
            () => {
                const topicAdminUrl = LibUtils.cleanupRouteParams(RoutePaths.TopicAdminList);
                if (document.location.pathname.indexOf(topicAdminUrl) > -1) {
                    this.props.history.replace(topicAdminUrl, { reloadKey: new Date().getTime().toString() } as TopicAdminRouteStateProps);
                }
            });
    };

    ///
    private handleAction(action: string) {
        switch (action) {
            case "list": {
                this.setState({ dlg: publicationFactory(null, PublicationType.List, this.handleClosePublication, { isPublic: true }) });
                break;
            }
            case "poll": {
                this.setState({ dlg: publicationFactory(null, PublicationType.Poll, this.handleClosePublication) });
                break;
            }
            case "post": {
                this.setState({ dlg: publicationFactory(null, PublicationType.Post, this.handleClosePublication) });
                break;
            }
            case "question": {
                this.setState({ dlg: publicationFactory(null, PublicationType.Question, this.handleClosePublication) });
                break;
            }
            case "topic": {
                this.setState({ dlg: <TopicEdit dialogMode topicId={null} onClose={this.handleCloseTopic} /> });
                break;
            }
        }

        this.setState({ open: false });
    }

    ///
    private getPublisherOptions() {
        const { classes } = this.props;
        var arr = [];
        arr.push(<MenuItem key="post" onClick={(e) => this.handleAction('post')} className={classes.menuItem}> <PublicationTypeName publicationType={PublicationType.Post} /></MenuItem>);
        arr.push(<MenuItem key="question" onClick={(e) => this.handleAction('question')} className={classes.menuItem}><PublicationTypeName publicationType={PublicationType.Question} /></MenuItem>);
        arr.push(<MenuItem key="poll" onClick={(e) => this.handleAction('poll')} className={classes.menuItem}><PublicationTypeName publicationType={PublicationType.Poll} /></MenuItem>);
        arr.push(<MenuItem key="list" onClick={(e) => this.handleAction('list')} className={classes.menuItem}><PublicationTypeName publicationType={PublicationType.List} /></MenuItem>);
        return arr;
    }

    ///
    private getTopicOptions() {
        const { classes } = this.props;
        var arr = [];
        arr.push(<MenuItem key="topic" onClick={(e) => this.handleAction('topic')} className={classes.menuItem}>{this.props.t("Common.Literals.TopicText")}</MenuItem>);
        return arr;
    }

    ///
    public render() {
        const hasPublisher = Session.hasRole(SystemRoles.Publisher);
        const hasTopic = Session.hasRole(SystemRoles.TopicCreator | SystemRoles.TopicManager);

        if (!hasPublisher && !hasTopic) {
            return null;
        }

        const { classes } = this.props;
        return (
            <>
                {this.state.dlg}

                <HeaderLinkButton
                    accessKey={AccessKeys.CreateContent}
                    classes={classes}
                    icon={<IconCreatePublication />}
                    tooltip={this.props.t("Common.TopHeader.QuickActionTitle")}
                    open={this.state.open}
                    handleClose={() => this.handleClosePublication(null)}
                    handleToggle={() => this.handleToggle()}
                >
                    <MenuList role="menu">
                        {hasPublisher && this.getPublisherOptions()}
                        {hasPublisher && hasTopic && <Divider key="div1" />}
                        {hasTopic && this.getTopicOptions()}
                    </MenuList>
                </HeaderLinkButton>
            </>
        );
    }
}

export default withTranslation()(withRouter(withSnackbar(HeaderCreationMenu)));